import { render, staticRenderFns } from "./Tixian.vue?vue&type=template&id=1d42a9ec&"
import script from "./Tixian.vue?vue&type=script&lang=js&"
export * from "./Tixian.vue?vue&type=script&lang=js&"
import style0 from "./Tixian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports